<template>
  <div class="enroll-info-student-detail"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="detailInfo">
      <AppScrollbar style="height: 100%">
        <div class="detail-main">
          <div v-if="detailInfo.admissionNo"
               class="prepend">
            <span>准考证号：</span>
            <span class="value">{{detailInfo.admissionNo}}</span>
          </div>
          <table>
            <colgroup>
              <col width="106px"/>
              <col/>
              <col width="106px"/>
              <col/>
              <col width="106px"/>
              <col/>
            </colgroup>
            <tr>
              <td class="label">姓名</td>
              <td class="value">{{detailInfo.trueName}}</td>
              <td class="label">性别</td>
              <td class="value">{{detailInfo.gender}}</td>
              <td class="label">出生日期</td>
              <td class="value">{{detailInfo.birthDate}}</td>
            </tr>
            <tr>
              <td class="label">籍贯</td>
              <td class="value">{{detailInfo.fromOrigin}}</td>
              <td class="label">民族</td>
              <td class="value">{{detailInfo.folk}}</td>
              <td class="label">政治面貌</td>
              <td class="value">{{detailInfo.polity}}</td>
            </tr>
            <tr>
              <td class="label">证件号码</td>
              <td class="value">{{detailInfo.idCard}}</td>
              <td class="label">报考教学点</td>
              <td class="value">{{detailInfo.siteName}}</td>
              <td class="label">意向上课地点</td>
              <td class="value">{{detailInfo.intendClassLocation}}</td>
            </tr>
            <tr>
              <td class="label">工作单位</td>
              <td class="value">{{detailInfo.workUnit}}</td>
              <td class="label">单位性质</td>
              <td class="value">{{detailInfo.workUnitType}}</td>
              <td class="label">所属行业</td>
              <td class="value">{{detailInfo.industry}}</td>
            </tr>
            <tr>
              <td class="label">工作职能</td>
              <td class="value">{{detailInfo.jobFunction}}</td>
              <td class="label">职务</td>
              <td class="value">{{detailInfo.jobDuty}}</td>
              <td class="label">职称</td>
              <td class="value">{{detailInfo.jobTitle}}</td>
            </tr>
            <tr>
              <td class="label">联系电话</td>
              <td class="value">{{detailInfo.phone}}</td>
              <td class="label">手机</td>
              <td class="value">{{detailInfo.mobilePhone}}</td>
              <td class="label">电子邮箱</td>
              <td class="value">{{detailInfo.email}}</td>
            </tr>
            <tr>
              <td class="label">地址</td>
              <td colspan="3" class="value">{{detailInfo.address}}</td>
              <td class="label">所在地市</td>
              <td class="value">{{detailInfo.fromRegion}}</td>
            </tr>
            <tr>
              <td class="label">最终学历</td>
              <td class="value">{{detailInfo.degree}}</td>
              <td class="label">毕业院校</td>
              <td class="value">{{detailInfo.graduateSchool}}</td>
              <td class="label">毕业专业</td>
              <td class="value">{{detailInfo.graduateMajor}}</td>
            </tr>
            <tr>
              <td class="label">成绩</td>
              <td colspan="5" class="value">
                <table class="inner">
                  <tr>
                    <th>英语</th>
                    <th>综合</th>
                    <th>面试</th>
                    <th>总分</th>
                  </tr>
                  <tr>
                    <td>{{detailInfo.englishScore}}</td>
                    <td>{{detailInfo.synthesisScore}}</td>
                    <td>{{detailInfo.interviewScore}}</td>
                    <td>{{detailInfo.totalScore}}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-if="detailInfo.experiences && detailInfo.experiences.length">
              <td class="label">经历</td>
              <td colspan="5" class="value">
                <table class="inner">
                  <tr>
                    <th>起止年月</th>
                    <th>学习或工作单位</th>
                    <th>任何职务</th>
                  </tr>
                  <tr v-for="experience in detailInfo.experiences"
                      :key="experience.id">
                    <td class="value">{{experience.dateRange}}</td>
                    <td class="value">{{experience.content}}</td>
                    <td class="value">{{experience.position}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>学生详情加载失败</div>
        <el-button type="text"
                   @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'EnrollInfoStudentDetail',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object
  },
  data () {
    return {
      loading: false,
      detailInfo: null
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enroll/info/student/detailInfo',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.detailInfo = response.data['detailInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadDetailInfo()
  }
}
</script>

<style lang="scss">
  .enroll-info-student-detail {
    height: 100%;
    background-color: #fff;
    .detail-main {
      padding: 20px 25px;
      & > .prepend {
        margin-bottom: 15px;
        font-size: 12px;
        & > .value {
          font-weight: bold;
        }
      }
      table {
        width: 100%;
        table-layout: fixed;
        border: 1px solid #dcdfe6;
        border-collapse: collapse;
        tr {
          td {
            font-size: 12px;
            padding: 10px;
            text-align: left;
            border: 1px solid #dcdfe6;
            word-break: break-all;
            word-wrap: break-word;
            &.label {
              color: #606266;
              font-weight: normal;
              background-color: #f3f4f5;
              &:after {
                content: '\ff1a';
              }
            }
            &.value {
              position: relative;
              color: #303133;
              font-weight: bold;
              &:empty {
                &:before {
                  content: '\002f';
                  color: #909399;
                }
              }
              .inner {
                border-color: white;
                tr {
                  th,
                  td {
                    padding: 6px 8px;
                    text-align: center;
                    border: 1px solid #fff;
                  }
                  th {
                    color: #606266;
                    font-weight: normal;
                    background-color: #ebecee;
                  }
                  td {
                    color: #303133;
                    font-weight: bold;
                    background-color: #f3f4f5;
                    &:empty {
                      &:before {
                        content: '\002f';
                        color: #909399;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
